import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './imprint.actions';

@Injectable()
export class ImprintEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadDealerImprint$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerImprint),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerOrVehicleMarketDealer)),
            switchMap(([, dealer]) => {
                if (!dealer) {
                    return of(actions.loadDealerImprintFailure({ error: 'No dealer found' }));
                }
                return from(this.dealerApi.getImprintContent(dealer.slug)).pipe(
                    switchMap((imprint) => [actions.loadDealerImprintSuccess({ imprint })]),
                    catchError((error) => of(actions.loadDealerImprintFailure({ error }))),
                );
            }),
        );
    });

    loadDealerImprintOverlayBySlug$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerImprintOverlayBySlug),
            switchMap(({ slug }) =>
                from(this.dealerApi.getImprintContent(slug)).pipe(
                    switchMap((imprint) => [actions.loadDealerImprintSuccess({ imprint })]),
                    catchError((error) => of(actions.loadDealerImprintFailure({ error }))),
                ),
            ),
        );
    });
}
